import React from 'react';
import { Trans } from 'react-i18next';
import UserLink from '../../../User/Link/UserLink';
import { GallectionResourceType } from '../../../types/gallection';
import { BiLoggerContextProvider } from '../../../biLogger/BiLogger.context';
import CollectionLink from './CollectionLink';
import DeviationSidebarGrid from '../../_partials/DeviationSidebarGrid';
import s from './CollectionsBlock.scss';
export var CollectionBlock = function (_a) {
    var collection = _a.collection, deviations = _a.deviations, parentDeviation = _a.parentDeviation;
    return (React.createElement(BiLoggerContextProvider, { value: {
            sectionname: 'collections',
            section_typeid: GallectionResourceType.COLLECTION,
            sectionid: collection.folderId,
        } },
        React.createElement("div", { className: s['collection-header'] },
            React.createElement("div", { className: s['by-author-title'] },
                React.createElement(Trans, { i18nKey: "sidebar.collections.title" },
                    React.createElement(CollectionLink, { collection: collection, className: s['by-author'] }),
                    "\u00A0by\u00A0",
                    React.createElement(UserLink, { user: collection.owner, className: s['by-author'] })))),
        React.createElement(DeviationSidebarGrid, { streamId: "devpage-sidebar-collections", className: s['collection-grid'], parentDeviation: parentDeviation, deviations: deviations, maxRows: 1 })));
};
CollectionBlock.displayName = 'CollectionBlock';
export default CollectionBlock;
//# sourceMappingURL=CollectionBlock.js.map